var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"logo"},[_vm._v("萨岗陀骆")]),_c('div',{staticClass:"contact"},[_vm._v("加盟热线：18189919488")]),_c('div',{staticClass:"footer-content"},[_vm._v("Copyright © 2022-2025 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("藏ICP备2024002292号-2")])])])
}]

export { render, staticRenderFns }